import { useState } from 'react'
import { UseOrder } from './order.types'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'
import { ORDER_DETAILS_ID } from './order.constants'

export const useOrder: UseOrder = () => {
  const [openAccordion, setOpenAccordion] = useState<string>(ORDER_DETAILS_ID)
  const checkoutInfo = queryClient.getQueryData([
    'checkout-info',
  ]) as CheckoutInfo

  const onChange = (openAccordion: string) => {
    setOpenAccordion(openAccordion)
  }

  return {
    onChange,
    openAccordion,
    order: checkoutInfo.payment_link.additional_data.order,
    airline: checkoutInfo.payment_link.additional_data.airline,
    totalDue: checkoutInfo.payment_link.amount.value,
    currency: checkoutInfo.payment_link.amount.currency,
    hasProducts: Boolean(
      checkoutInfo.payment_link.additional_data.order?.items?.length
    ),
    description: checkoutInfo.payment_link.description,
  }
}
